<template>
    <app-wrapper>
        <app-header medium-max-width="max-w-1000" :is-hidden-menu="true">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto text-center">
                        <h2 class="mb-1 mt-0 md:text-4xl">Review and Confirm Your Updated Terms</h2>
                        <span class="text-gray-500">Review your updated loan details. Once confirmed, your cash will be on the way.</span>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #main>


                <AppBoxContent 
                    class="my-6"
                    width="full" 
                    rounded="lg"
                    padding="p-4 md:p-10"
                    bg-class-color="bg-white" 
                    :use-min-height="false"
                    :remove-max-width="true"
                >
                    

                    <div>
                        <p>Cash you’ll receive today</p>
                        <p><FontBold class="text-4xl">{{ cashBackAmount | formatMoney }}</FontBold></p>
                    </div>

                    <SimpleDivider class="my-6" />

                    <div>
                        <p>New loan total</p>
                        <p><FontBold class="text-4xl">{{ newLoanAmount | formatMoney }}</FontBold></p>
                    </div>

                    <SimpleDivider class="my-6" />

                    <div class="flex">
                        <div class="min-w-[150px]">Current balance</div>
                        <div>{{ storeData.payoff | formatMoney }}</div>
                    </div>

                    <div class="flex">
                        <div class="min-w-[150px]">Cash added</div>
                        <div>+{{ cashBackAmount | formatMoney }}</div>
                    </div>

                    <SimpleDivider class="my-6" />

                    <div class="flex">
                        <div class="min-w-[150px]">Loan term</div>
                        <div>24 months</div>
                    </div>

                    <div class="flex">
                        <div class="min-w-[150px]">Monthly payment</div>
                        <div>No change</div>
                    </div>

                </AppBoxContent>
                

                <div class="action-buttons text-center mt-4">
                    <div v-if="errors.global" class="mb-4 p-4 bg-red-50 rounded-lg border border-red-200">
                        <p class="text-red-800 text-sm">{{ errors.global }}</p>
                    </div>
                    <div v-if="errors.cash_back_amount" class="mb-4 p-4 bg-red-50 rounded-lg border border-red-200">
                        <p class="text-red-800 text-sm">{{ errors.cash_back_amount }}</p>
                    </div>
                    <div>
                        <LinkButton 
                            class="mb-1" 
                            data-testid="submit-refi"
                            href="#" 
                            @click="submitRefi()"
                            :disabled="loading"
                            type="orange">{{ loading ? 'Processing...' : 'Confirm & Receive ' + formatMoney(cashBackAmount) }}</LinkButton>
                    </div>
                    <div>
                        <LinkButton 
                            href="#" 
                            type="grey">Return to Portal</LinkButton>
                    </div>
                </div>

            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import AppBoxContent from '../../../../components/AppBoxContent.vue';
import FontBold from '../components/FontBold.vue';
import SimpleDivider from '../components/SimpleDivider.vue';
import LinkButton from '../components/LinkButton.vue';
import { RefinanceStepMixin } from './../mixins/RefinanceStepMixin';
import { RefinanceFiltersMixin } from './../mixins/RefinanceFiltersMixin';

export default {
    name: 'RefinanceConfirmation',
    mixins: [RefinanceStepMixin, RefinanceFiltersMixin],
    components: {
        AppBoxContent,
        FontBold,
        SimpleDivider,
        LinkButton,
    },

    data() {
        return {
        }
    },
}
</script>

